module.exports = __webpack_public_path__ + "static/media/emojis_28.4f2eed40.svg";